import { useViewedVehicle } from 'pages/Admin/ViewVehicle/hooks/useViewedVehicle';
import { useExteriorSectionData } from '../useExteriorSection';
import { useLevel1SectionData } from '../useLevel1Section';

export const useDriveCycleSections = () => {
  const { subSections } = useLevel1SectionData('drive_cycles');
  const { subSections: exteriorSubSections } = useExteriorSectionData('exterior');
  const vehicle = useViewedVehicle();

  const isManual = vehicle?.transmission?.toLowerCase().startsWith('manual');
  const is4WD = vehicle?.drive_train?.toLowerCase() === '4wd';

  const sections = [
    subSections.how_vehicle_runs_overall,
    subSections.engine_light_acceleration,
    subSections.engine_medium_acceleration,
    subSections.engine_heavy_acceleration,
    subSections.engine_noises,
    subSections.how_transmission_shifts,
    subSections.transmission_light_acceleration,
    subSections.transmission_medium_acceleration,
    subSections.transmission_heavy_acceleration,
    subSections.transmission_shudder,
    exteriorSubSections.suspension_alterations,
    exteriorSubSections.suspension_operations,
    exteriorSubSections.exhaust_sounds_factory,
    exteriorSubSections.catalytic_converter_present,
    subSections['3_point_turn_cv_reserve_test'],
    subSections.vehicle_breaking,
    subSections.how_engine_runs_overall
  ];

  if (isManual) {
    sections.push(
      subSections.position_of_clutch_pedal,
      subSections.clutch_engages_in_gear,
      subSections.manual_transmission_engages_every_gear
    );
  }

  if (is4WD) {
    sections.push(subSections.engage_in_low_4x4, subSections.engage_in_high_4x4);
  }

  return sections;
};
